// DON-677: Social login relay a login modalhoz.
// A social gombok az apex /writer-login relay-oldalara mutato linkek (a Google/Apple
// OAuth csak elore regisztralt originrol futhat, az aldomainrol nem) — a belepes az
// apexen tortenik, a szerver a ?ret= cimre hoz vissza. Itt csak annyi a dolgunk,
// hogy feliratkozasi szandeknal (pendingSubscribe, ld. 05-login.js) a linket
// followchannel parammal egeszitsuk ki, hogy a belepes utan a szerver fel is
// iratkoztasson.
document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('.js-writer-social-relay');
    if (!link || !link.href) return;
    var loginModal = document.getElementById('loginModal');
    if (loginModal && loginModal.dataset.pendingSubscribe === '1' && link.dataset.followchannel) {
        e.preventDefault();
        window.location.href = link.href + '&followchannel=' + encodeURIComponent(link.dataset.followchannel);
    }
});
